import { Col, Row } from "../components/layout.jsx";
import {
  Headline,
  ImageHeader,
  MainContent,
} from "../templates/common/Components.jsx";
import Tooltip, { ArchivedTooltipContent } from "../components/Tooltip.jsx";
import { color, styled, theme } from "../util/style.js";

import BudgetHeader from "../components/BudgetHeader.jsx";
import { Button } from "../components/typography.jsx";
import Container from "../templates/common/Container.jsx";
import LoggedInTemplate from "../templates/LoggedInTemplate.jsx";
import TrainingVoucherItem from "../components/TrainingVoucherItem.jsx";
import header from "../img/bandeau_formations.jpg";
import { paths } from "../services/router.js";
import { usePagination } from "../components/Pagination.jsx";
import { usePermissions } from "../services/permissions.js";
import { useRef } from "react";
import { useSelfMetaData } from "../services/self.js";
import { useTrainingVouchers } from "../services/trainingVouchers.js";

const DEFAULT_LIMIT = 100;

const Panel = styled.div`
  background: white;
  border-radius: ${theme("border-radius")};
  padding: ${theme("padding-container")};
  margin-bottom: 36px;
`;
const GreyContent = styled.div`
  background: ${color("bg-light")};
  border-radius: ${theme("border-radius")};
  padding: ${theme("padding-container")};
`;

const TrainingVouchersList = styled.div`
  ${TrainingVoucherItem} + ${TrainingVoucherItem} {
    margin-top: 30px;
  }
`;

const ScrollRef = styled.div`
  position: relative;
  top: -100px;
`;

export default function TrainingVouchers() {
  const { isArchived, company } = useSelfMetaData();
  const [hasPermission] = usePermissions();

  const budgetTraining = company?.budgets?.formations;

  const topScroll = useRef();
  const pagination = usePagination(DEFAULT_LIMIT);
  const [trainingVouchersResult, { ready, refetch }] = useTrainingVouchers(
    {},
    pagination,
  );

  const trainingVouchers = (trainingVouchersResult?.edges || []).map(
    ({ node }) => node,
  );

  return (
    <LoggedInTemplate title="Bons d'achat formation">
      <ImageHeader
        image={header}
        icon="school-line"
        label="Bons d'achat formation"
      />
      <MainContent>
        <Headline title="Mes bons d'achat formation" />
        <Container>
          <BudgetHeader
            budget={budgetTraining}
            budgetButton={
              <Button
                to={paths.trainingVoucherCreate}
                disabled={budgetTraining?.totalBalance?.amount <= 0}
              >
                Je créé un bon
              </Button>
            }
          />
          <Row>
            <Col kind="aside">
              <Panel>
                <GreyContent>
                  <p>
                    Les bons d'achat vous servent à utiliser votre budget
                    formation Daikin.
                  </p>
                  <p>
                    <strong>Étape 1</strong> - Je clique sur « Commander une
                    session » pour choisir ma session sur l'espace formation
                    Daikin
                    <br />
                    <strong>Étape 2</strong> - Je commande ma session de
                    formation
                    <br />
                    <strong>Étape 3</strong> - Je retourne sur ELITE pour créer
                    mon bon d'achat au montant souhaité (Ce montant viendra en
                    déduction de votre commande)
                    <br />
                    <strong>Étape 4</strong> - Ma session est commandée et mon
                    budget automatiquement décompté
                  </p>

                  <p style={{ textAlign: "center" }}>
                    <Button
                      to={paths.trainingPlatform}
                      disabled={!hasPermission("training:order")}
                    >
                      Commander une session
                    </Button>
                    {isArchived && (
                      <Tooltip
                        align="center"
                        content={<ArchivedTooltipContent />}
                      ></Tooltip>
                    )}
                  </p>

                  <p style={{ marginTop: "32px" }}>
                    Une question ou une demande sur vos bons d'achat formation ?
                  </p>
                  <p style={{ textAlign: "center" }}>
                    <Button
                      to={{
                        pathname: paths.trainingTutorial,
                      }}
                      ghost
                    >
                      Consultez le tutoriel
                    </Button>
                    <br />
                    ou
                    <br />
                    <Button
                      to={{
                        pathname: paths.contact,
                        search: `?title=formations`,
                      }}
                      ghost
                    >
                      Contactez-nous
                    </Button>
                  </p>
                </GreyContent>
              </Panel>
            </Col>
            <Col kind="main">
              <ScrollRef ref={topScroll} />
              <TrainingVouchersList>
                {trainingVouchers.length ? (
                  trainingVouchers.map((trainingVoucher) => (
                    <TrainingVoucherItem
                      {...trainingVoucher}
                      key={trainingVoucher.id}
                      onUpdate={refetch}
                    />
                  ))
                ) : (
                  <Panel>
                    <h3>Aucun bon d'achat formation</h3>
                    <div>
                      Vous n'avez pas créé de bon d'achat formation pour cette
                      année.
                    </div>
                  </Panel>
                )}
              </TrainingVouchersList>
            </Col>
          </Row>
        </Container>
      </MainContent>
    </LoggedInTemplate>
  );
}
